var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('div',{staticClass:"footer-content"},[_c('span',[_vm._v("Powered by ")]),_c('strong',[_vm._v("Blastness SPA")])])])
}]

export { render, staticRenderFns }